import { useLocalization } from 'Hooks';

const transactionTypeParser = (transactionType: string) => {
  const { transactions_loading } = useLocalization();
  return transactions_loading?.includes(transactionType);
};

export default transactionTypeParser;
